export default "__VITE_ASSET__DBb6J9WE__"